/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';
import type {
  InfiniteData,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { GetExItemsParams } from '../model/getExItemsParams';
import type { GetExItemsResponse } from '../model/getExItemsResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Get a list of ex items
 */
export const useGetExItemsHook = () => {
  const getExItems = useCustomClient<GetExItemsResponse>();

  return (
    params?: GetExItemsParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return getExItems(
      { url: `/api/js/ex_items`, method: 'GET', params },
      options
    );
  };
};

export const getGetExItemsQueryKey = (params?: GetExItemsParams) => {
  return [`/api/js/ex_items`, ...(params ? [params] : [])] as const;
};

export const useGetExItemsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
    GetExItemsParams['page']
  >,
  TError = ErrorType<unknown>
>(
  params?: GetExItemsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
        QueryKey,
        GetExItemsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExItemsQueryKey(params);

  const getExItems = useGetExItemsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
    QueryKey,
    GetExItemsParams['page']
  > = ({ pageParam }) =>
    getExItems(
      { ...params, page: pageParam || params?.['page'] },
      requestOptions
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
    TError,
    TData,
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
    QueryKey,
    GetExItemsParams['page']
  > & { queryKey: QueryKey };
};

export type GetExItemsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>
>;
export type GetExItemsInfiniteQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of ex items
 */
export const useGetExItemsInfinite = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
    GetExItemsParams['page']
  >,
  TError = ErrorType<unknown>
>(
  params?: GetExItemsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
        QueryKey,
        GetExItemsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetExItemsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetExItemsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
  TError = ErrorType<unknown>
>(
  params?: GetExItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExItemsQueryKey(params);

  const getExItems = useGetExItemsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>
  > = () => getExItems(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetExItemsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>
>;
export type GetExItemsQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of ex items
 */
export const useGetExItems = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
  TError = ErrorType<unknown>
>(
  params?: GetExItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetExItemsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetExItemsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
  TError = ErrorType<unknown>
>(
  params?: GetExItemsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExItemsQueryKey(params);

  const getExItems = useGetExItemsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>
  > = () => getExItems(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetExItemsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>
>;
export type GetExItemsSuspenseQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of ex items
 */
export const useGetExItemsSuspense = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
  TError = ErrorType<unknown>
>(
  params?: GetExItemsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetExItemsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetExItemsSuspenseInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
    GetExItemsParams['page']
  >,
  TError = ErrorType<unknown>
>(
  params?: GetExItemsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
        QueryKey,
        GetExItemsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExItemsQueryKey(params);

  const getExItems = useGetExItemsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
    QueryKey,
    GetExItemsParams['page']
  > = ({ pageParam }) =>
    getExItems(
      { ...params, page: pageParam || params?.['page'] },
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    ...queryOptions,
  } as UseSuspenseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
    TError,
    TData,
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
    QueryKey,
    GetExItemsParams['page']
  > & { queryKey: QueryKey };
};

export type GetExItemsSuspenseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>
>;
export type GetExItemsSuspenseInfiniteQueryError = ErrorType<unknown>;

/**
 * @summary Get a list of ex items
 */
export const useGetExItemsSuspenseInfinite = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
    GetExItemsParams['page']
  >,
  TError = ErrorType<unknown>
>(
  params?: GetExItemsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetExItemsHook>>>,
        QueryKey,
        GetExItemsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetExItemsSuspenseInfiniteQueryOptions(
    params,
    options
  );

  const query = useSuspenseInfiniteQuery(
    queryOptions
  ) as UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
